/* import __COLOCATED_TEMPLATE__ from './topic-selector.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type { PlaygroundQuestionGeneration } from 'embercom/lib/fin-playground/question-generation';

interface Signature {
  Args: {
    questionGeneration?: PlaygroundQuestionGeneration;
    selectedTopic?: string;
    onTopicChange: (topicId?: string) => void;
    placeholder?: string;
    searchPlaceholder?: string;
    disabled?: boolean;
    testSelector?: string;
  };
}

export default class TopicSelector extends Component<Signature> {
  @service declare intl: IntlService;

  get availableTopics() {
    let topics = this.args.questionGeneration?.availableTopics ?? [];

    if (topics.length === 0) {
      return [];
    }

    return [
      {
        heading: this.intl.t('ai-agent.playground.modal.question-generation.topics.column-topic'),
        items: topics,
      },
    ];
  }

  get hasTopics() {
    return this.args.questionGeneration?.hasTopics ?? false;
  }

  get selectedTopicName() {
    if (!this.args.selectedTopic) {
      return null;
    }

    // Find the selected topic within the entities structure
    for (let entity of this.availableTopics) {
      let selectedItem = entity.items.find((topic) => topic.value === this.args.selectedTopic);
      if (selectedItem) {
        return selectedItem.text;
      }
    }

    return null;
  }

  get placeholder() {
    return (
      this.args.placeholder ||
      this.intl.t('ai-agent.playground.modal.question-generation.topics.select-topic')
    );
  }

  get searchPlaceholder() {
    return (
      this.args.searchPlaceholder ||
      this.intl.t('ai-agent.playground.modal.question-generation.topics.search-placeholder')
    );
  }

  @action
  updateTopicSelection(topicId: string) {
    this.args.onTopicChange(topicId);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Playground::TopicSelector': typeof TopicSelector;
    'ai-agent/playground/topic-selector': typeof TopicSelector;
  }
}
